<!-- 标签管理列表 -->
<template>
    <div id="goodSearch" class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">企业名称</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.EntpName" placeholder="请输入申请企业名称"></el-input>
                <div class="search-name">审核状态</div>
                <el-select class="search-item" size="small" v-model="searchData.State">
                    <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                </el-select>
                <div class="search-name">申请时间</div>
                <el-date-picker
                    v-model="dateTimes"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    @change="handleChange"
                    size="small"
                    class="search-name"
                ></el-date-picker>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <template v-if="noData">
            <div class="no-data">暂无数据</div>
        </template>
        <template v-else>
            <div class="table-ctn">
                <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
                    <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
                    <el-table-column width="180px" prop="EntpName" label="申请企业" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-link @click="showEntpInfoes(scope.row.EntpId)" type="primary" :underline="false">{{ scope.row.EntpName }}</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="150px" prop="ApplyInfo" label="申请信息" show-overflow-tooltip></el-table-column>
                    <el-table-column width="160px" prop="ApplyTime" label="申请时间" show-overflow-tooltip></el-table-column>
                    <el-table-column width="120px" prop="State" label="审核状态" show-overflow-tooltip></el-table-column>
                    <el-table-column width="160" prop="CheckTime" label="审核时间" show-overflow-tooltip
                        ><template slot-scope="scope">{{ scope.row.State == '未审核' ? '' : scope.row.CheckTime }}</template></el-table-column
                    >
                    <el-table-column width="120px" prop="Checker" label="审核人" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="200px" prop="CheckRemark" label="审核结果" show-overflow-tooltip></el-table-column>
                    <el-table-column fixed="right" label="操作" :autoWidth="true">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button type="text" size="mini" @click="checkApply(scope.row)" v-if="permission.checkApply && scope.row.State == '未审核'">{{
                                    permission.checkApply
                                }}</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
        </template>
        <el-dialog :close-on-click-modal="false" title="申请企业信息" :visible.sync="dialogEntpVisible" width="1000px">
            <div class="dialog-content" v-if="dialogEntpVisible">
                <EntpDatas ref="customerEdit" :entpId="entpId" @closeDialog="closeEntpDialog"></EntpDatas>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import EntpDatas from '@/components/entpUnion/entityManage/entpDatas';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'labels',
    components: {
        breadcrumb,
        elTableColumn,
        EntpDatas
    },
    data() {
        return {
            searchData: {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                EntpName: '',
                State: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            },
            dateTimes: '',
            noData: false,
            entpId: '',
            dialogEntpVisible: false,
            tableData: [],
            tableDataLength: 0,
            permission: {},
            stateList: [
                { Text: '全部', Value: '' },
                { Text: '未审核', Value: '0' },
                { Text: '审核通过', Value: '1' },
                { Text: '审核不通过', Value: '2' }
            ],
            multipleSelection: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getTableData();
        this.permission = this.$util.getUnionPermission('UnionJoinCheck');
    },
    methods: {
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        // 重置表单
        resetSearch() {
            this.searchData = {
                UnionId: this.$util.getLocalStorage('currentUnion'),
                EntpName: '',
                State: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            };
            this.dateTimes = [];
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpUnions/GetUnionApplyList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        this.noData = true;
                        return;
                    }
                    this.noData = false;
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        showEntpInfoes(entpId) {
            if (entpId) {
                this.dialogEntpVisible = true;
                this.entpId = entpId;
            }
        },
        closeEntpDialog() {
            this.dialogEntpVisible = false;
        },
        checkApply(item) {
            if (item) {
                let that = this;

                that.$confirm('审核该条入盟审核, 您的选择是?', '提示', {
                    confirmButtonText: '确认通过',
                    cancelButtonText: '未通过审核',
                    type: 'warning',
                    center: false,
                    distinguishCancelAndClose: true
                })
                    .then(() => {
                        that.loading = true;
                        that.$util
                            .axiosPost({
                                url: '/api/EntpUnions/ConfirmUnionApplys',
                                data: { ApplyId: item.RecordId, Type: 1 },
                                hideLoading: true
                            })
                            .then(() => {
                                that.$util.successMsg('已通过审核，请到成员信息里设置相关的权限哟');
                                that.getTableData();
                            })
                            .finally(() => {
                                that.loading = false;
                            });
                    })
                    .catch(action => {
                        if (action === 'cancel') {
                            that.$prompt('请输入不通过的原因', '提示', {
                                confirmButtonText: '提交',
                                cancelButtonText: '取消'
                            })
                                .then(({ value }) => {
                                    that.loading = true;
                                    that.$util
                                        .axiosPost({
                                            url: '/api/EntpUnions/ConfirmUnionApplys',
                                            data: { ApplyId: item.RecordId, Type: 0, Message: value },
                                            hideLoading: true
                                        })
                                        .then(() => {
                                            that.$util.warningMsg('已拒绝对方入盟申请');
                                        })
                                        .finally(() => {
                                            that.loading = false;
                                        });
                                })
                                .catch(() => {});
                        }
                    });
            }
        }
    }
};
</script>
